const mockWallet = [
    { name: 'Cash', icon: '/assets/icons/wallets/cash.svg' },
    { name: 'Card', icon: '/assets/icons/wallets/card.svg' },
    { name: 'Saving', icon: '/assets/icons/wallets/saving.svg' },
    { name: 'Credit card', icon: '/assets/icons/wallets/credit-card.svg' }
]

export default mockWallet